import {
  ALL_DRAFT_DATA_DATA,
  ALL_POST_DATA_DATA,
  ALL_POST_SEARCH_DATA_DATA,
  CREATE_POST_LOADER,
  GET_ALL_POST_LOADER,
  POST_DATA_DATA,
  GET_SINGLE_POST_LOADER,
  SINGLE_POST_DATA_DATA,
} from '../action/Post';

const initialState = {
  createPostLoader: false,
  getBookPost: false,
  getAllPostLoader: false,
  getAllPost: false,
  singlePostLoader: true,
  singlePost: false,
  draftPost: false,
  getAllSearchPost: false,
  hadithSearchData: false,
  hadithOfTheDayData: false,
  hadithOfTheMonthData: false,
};

const ContentReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_POST_LOADER:
      return {
        ...state,
        createPostLoader: action.payload,
      };
    case POST_DATA_DATA:
      return {
        ...state,
        getBookPost: action.payload,
      };
    case GET_ALL_POST_LOADER:
      return {
        ...state,
        getAllPostLoader: action.payload,
      };
    case ALL_POST_DATA_DATA:
      return {
        ...state,
        getAllPost: action.payload,
      };
    case GET_SINGLE_POST_LOADER: {
      return {
        ...state,
        singlePostLoader: action.payload,
      };
    }
    case SINGLE_POST_DATA_DATA:
      return {
        ...state,
        singlePost: action.payload,
      };
    case ALL_DRAFT_DATA_DATA:
      return {
        ...state,
        draftPost: action.payload,
      };
    case ALL_POST_SEARCH_DATA_DATA:
      return {
        ...state,
        getAllSearchPost: action.payload.data,
        totalDocuments: action.payload.totalDocuments,
      };

    default:
      return {
        ...state,
      };
  }
};
export default ContentReducer;
